import React from 'react'

import { FooterContainer } from 'Footer'
import classNames from 'classnames'
import Immutable from 'immutable'
import PropTypes from 'prop-types'

import { MenuHeader } from './MenuHeader'

import css from './MainLayout.css'

const propTypes = {
  children: PropTypes.node.isRequired,
  preHeaderContent: PropTypes.node,
  isAuthenticated: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  orders: PropTypes.instanceOf(Immutable.Map),
  shippingAddresses: PropTypes.instanceOf(Immutable.List),
  userLoadOrders: PropTypes.func.isRequired,
  userFetchShippingAddresses: PropTypes.func.isRequired,
  userClearData: PropTypes.func.isRequired,
  menuLoadingBoxPrices: PropTypes.bool, // eslint-disable-line react/no-unused-prop-types
  menuLoadBoxPrices: PropTypes.func.isRequired,
  route: PropTypes.shape({
    withRecipeBar: PropTypes.bool,
    footerType: PropTypes.string,
  }),
}

const defaultProps = {
  orders: Immutable.fromJS({}),
  shippingAddresses: Immutable.List([]),
  menuLoadingBoxPrices: false,
  preHeaderContent: null,
  route: {},
}

export class MainLayout extends React.Component {
  componentDidMount() {
    const {
      disabled,
      isAuthenticated,
      orders,
      shippingAddresses,
      userFetchShippingAddresses,
      userLoadOrders,
    } = this.props

    if (!disabled) {
      if (isAuthenticated) {
        if (shippingAddresses.size < 1) {
          userFetchShippingAddresses()
        }
        if (orders.size < 1) {
          userLoadOrders()
        }
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProp) {
    const {
      disabled,
      isAuthenticated,
      menuLoadBoxPrices,
      shippingAddresses,
      userClearData,
      userFetchShippingAddresses,
      userLoadOrders,
    } = this.props

    if (!nextProp.disabled && !disabled) {
      if (!isAuthenticated && nextProp.isAuthenticated) {
        if (shippingAddresses.size < 1) {
          userFetchShippingAddresses()
        }
        if (nextProp.orders.size < 1) {
          userLoadOrders()

          if (!nextProp.menuLoadingBoxPrices) {
            menuLoadBoxPrices()
          }
        }
      } else if (isAuthenticated && !nextProp.isAuthenticated) {
        userClearData()
        menuLoadBoxPrices()
      }
    }
  }

  render() {
    const { children, preHeaderContent, route } = this.props
    const footerBaseClass = classNames(css.pageContainer, {
      [css.withBottomBar]: route.withRecipeBar,
    })

    return (
      <div className={footerBaseClass}>
        {preHeaderContent}
        <MenuHeader />
        {children}
        <div className={classNames({ [css.pullUp]: route.withRecipeBar })}>
          <FooterContainer type={route.footerType} />
        </div>
      </div>
    )
  }
}

MainLayout.propTypes = propTypes

MainLayout.defaultProps = defaultProps
